import React, { useState ,useEffect} from 'react'
import Header from '../Component/Header';
import Footer from '../Component/footer';
import PageHead from '../Component/pageHead'
import PageSubHead from '../Component/pageSubHead'
import PageBody from '../Component/pageBody'
import {GetAction} from '../Component/GetAction'

function Udesh() {
  const [title,setTitle] = useState('')
  const [subtitle,setSubTitle] = useState('')
  const [markup,setMarkup] = useState('')
  const [loading,setLoading] = useState(true)

    const requestAPI = async () => {
        try {
        const url = `/pages/page`;
        let reqParam = {
            page_id:1,
        }
        const res = await GetAction('get',reqParam,url)
        const response = res?.response
        if (response) {
        setTitle(response.title || '')
        setSubTitle(response.subTitle || '')
        setMarkup(response.description || '')
        }
        } finally {
        setLoading(false)
        }
        }
  useEffect(()=>{
        requestAPI();
    },[]);  
const static_markup = { __html: markup || '' };
  return (
    <>
    <Header /> 
    <PageHead title={title} />
    <PageSubHead title={subtitle} />

    <div className='container' style={{fontSize:20,minHeight:"500px"}}>
    {loading ? <p className="text-center text-muted">Loading...</p> : null}
    {!loading && markup ? <PageBody data={static_markup} /> : null}
    {!loading && !markup ? <p className="text-center text-muted">Content is not available right now.</p> : null}
    </div>
     <Footer /> 
    </>
  )
}

export default Udesh
